import React from 'react'
import { Route, Switch, useRouteMatch } from 'react-router-dom'
import AllergiesandMedication from '../../components/BookConsultNow/Components/PatientMedicalComponent/Components/AllergiesandMedication/AllergiesandMedication';
import LifestyleAndPreExistingCondition from '../../components/BookConsultNow/Components/PatientMedicalComponent/Components/LifestyleAndPreExistingCondition/LifestyleAndPreExistingCondition';
import PatientVitals from '../../components/BookConsultNow/Components/PatientMedicalComponent/Components/Patient Vitals/PatientVitals';

function MedicalHistoryRoutes({ setActiveTop, onUnsavedChangesChange }) {

    let { path, url } = useRouteMatch();

    return (

        <Switch>

            <Route
                exact
                path={`${path}`}
                render={(props) => <PatientVitals {...props} setActiveTop={setActiveTop} onUnsavedChangesChange={onUnsavedChangesChange} />}
            />


            <Route
                exact
                path={`${path}/patientvitals`}
                render={(props) => <PatientVitals {...props} setActiveTop={setActiveTop} onUnsavedChangesChange={onUnsavedChangesChange} />}
            // component={BookConsultNow}
            />
            <Route
                exact
                path={`${path}/lifestyle`}
                render={(props) => <LifestyleAndPreExistingCondition {...props} setActiveTop={setActiveTop} onUnsavedChangesChange={onUnsavedChangesChange} />}
            />
            <Route
                exact
                path={`${path}/allergies`}
                component={AllergiesandMedication}
            />





        </Switch>
    )
}

export default MedicalHistoryRoutes